import { ExtendedSerie } from './serie.model';

export type Model = {
  id?: number;
  name: string;
  description: string | null;
  picture: string | File;
  serieId: number;
};
export type ExtendedModel = {
  id?: number;
  name: string;
  description: string | null;
  picture: string | File;
  serieId: number;
  serie?: ExtendedSerie;
};

export type Piece = {
  label: string;
  color: string;
  path: string;
  class?: string;
  x: number;
  y: number;
  width: number | string;
  height: number | string;
};

export enum PrintType {
  WINDOW = 'WINDOW',
  PPF = 'PPF',
}

export type PrintableData = {
  id?: number;
  modelId: number;
  preview?: string;
  pieces: Piece[];
  type: PrintType;
  bbox: { x: number; y: number; height: number | string; width: number | string };
};

export type ExtendedPrintableData = Omit<PrintableData, 'id'> & {
  id: number;
  model?: ExtendedModel;
};
